// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { FailedBurn } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Burn';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useFailedBurns: () => UseQueryResult<TemplateContract<FailedBurn>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  const offset = useLedgerEnd();

  return useQuery({
    queryKey: ['queryFailedBurns', offset, ledgerApi, operator],
    queryFn: async () => {
      return ledgerApi.queryFailedBurns(offset!, operator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useFailedBurns;
